<template>
  <div>
    <ButtonX />
    <b-container>
      <h1 id="tag-des-mauerfalls">Tag des Mauerfalls</h1>

      <div class="py-5">
        <video src="../media/Mauerfall.mp4" controls></video>
      </div>
      <p>
        Eine Dokumentation, von einem der Zeitzeugen aus dem Video findet ihr
        <a
          href="https://youtu.be/BAGJA_IRMUg"
        >(hier)</a>.
      </p>
      <div class="bib">
        <h2 class="bib">Quellen</h2>
        <p class="bib">Interviews mit Zeitzeugen, durchgeführt im Herbst 2020</p>
      </div>
      <Footer />
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>